import React, { useState, useEffect } from 'react';
import './BusinessServices.css';

const POWERBI_DESKTOP_URL = "https://app.powerbigov.us/view?r=eyJrIjoiZjI0ZThhMDktZjE3OC00MWJhLThkNjMtYTJjYzQ2OWYxZmIzIiwidCI6IjZhNjJmY2QyLTJlYzgtNDRlYi1hYWM1LTg4OTJhOGQ1YTgyNiJ9";
const POWERBI_MOBILE_URL = "https://app.powerbigov.us/view?r=eyJrIjoiMjNmYTk1N2ItNDdkMS00MzRlLTk0ZDAtYTQxNjQ0MjkxNzg0IiwidCI6IjZhNjJmY2QyLTJlYzgtNDRlYi1hYWM1LTg4OTJhOGQ1YTgyNiJ9";

const BusinessServices = () => {
  const [powerbiUrl, setPowerbiUrl] = useState(POWERBI_DESKTOP_URL);

  useEffect(() => {
    // Function to check screen size and set URL
    const updateUrl = () => {
      if (window.matchMedia("(max-width: 767px)").matches) {
        setPowerbiUrl(POWERBI_MOBILE_URL);
      } else {
        setPowerbiUrl(POWERBI_DESKTOP_URL);
      }
    };
    updateUrl();
    window.addEventListener('resize', updateUrl);
    return () => window.removeEventListener('resize', updateUrl);
  }, []);

  return (
    <div className="page-container">
      <h2 className="vr-header">Business Services</h2>
      <p className="intro">Welcome to Ohio’s Data Portal, your gateway to comprehensive and interactive
        information directly sourced from the Ohio Secretary of State's website. The Business Services
        page allows you to explore an interactive dashboard, find all necessary resources for business
        filings and notary searches, and access downloadable reports that keep your business informed
        and compliant. Explore these comprehensive tools today to empower your participation in these
        vital areas.
      </p>

      {/* First Section */}
      <section className="section">
        <h3 className="section-title">Business Services Dashboard</h3>
        <div className="powerbi-wrapper">
          <iframe
            title="Ohio Business Services Dashboard"
            className="powerbi-iframe"
            width="100%"
            height="750"
            src={powerbiUrl}
            frameBorder="0"
            allowFullScreen={true}
            style={{ border: '1px solid #cfd8dc', display: 'block' }}
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default BusinessServices;